function getCart() {
  return $.getJSON('/cart.js');
}

function updateCartAttribute(nameValuePair) {
  var update = {
    attributes: {}
  };

  update.attributes = nameValuePair;

  return new Promise(function(resolve, reject) {
    $.ajax('/cart/update.js', {
      type: 'POST',        
      data: update, 
      success: function() {
        resolve();
      }
    })
  });
}

function addItemToCart(p_options) {
  var data = {
    quantity: p_options.quantity,
    id: p_options.variant_id,
  };

  if (p_options.properties !== undefined) {
    data['properties'] = p_options.properties;
  }
  console.log(data);

  return new Promise(function(resolve, reject) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(data) { 
        resolve(data);
      },
      error: function(error) { 
        reject(error);
      }
    });
  });      
}

function updateCart(updates) {
  if (!updates) {
    return;
  }

  return new Promise(function(resolve, reject) {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      async: true,      
      data: {updates: updates},
      dataType: 'json',
      success: function(data) { 
        console.log(data);
        resolve(data);
      },
      error: function(error) { 
        console.error(error);
        reject(error);
      }
    });
  });    
}

function observeMutations(elementSelector, callback) {
  if (document.querySelectorAll(elementSelector).length == 0) {
    return;
  }
  var observer = new MutationObserver(callback);
  var config = { attributes: true, childList: true, characterData: false };
  observer.observe(document.querySelector(elementSelector), config);

  return observer;
}  

function onElementLoad(selector, callback) {
  var loaded = false;
  var timer = setInterval(function() {
    if (document.querySelectorAll(selector).length) {
      console.log(selector + ' loaded!');
      loaded = true;
    }

    if (loaded) {
      clearInterval(timer);
      callback();
    }
  }, 100);
}

(function($) {
  function refreshCartTotals() {
    getCart().then(function(cart) {
      $('.cart-subtotal__price').text(theme.Currency.formatMoney(cart.items_subtotal_price, theme.moneyFormatWithCurrency));
      
      var cart_items_count = cart.items.reduce(function(sum, item) {
        var qty = item.quantity;
        if (item.product_type == 'service-charge') {
          qty = 0;
        }
        return sum + qty;
      }, 0);
      
      $('[data-cart-count]').text(cart_items_count);
    });
  }
  
  function addServiceCharge(stairs_count) {
    updateCartAttribute({
      'Stairs count': stairs_count
    });
    
    getCart().then(function(cart) {
      var Percent = PERCENT_SERVICE_CHARGE;
      var cart_items = cart.items.filter(function(item) {return item.product_type !== 'service-charge'; });
      var service_charge_item = cart.items.filter(function(item) {return item.product_type == 'service-charge'; })
      var cart_total = cart_items.reduce(function(sum, item) {return sum + item.final_line_price}, 0);

      var total_service_charge = (cart_total / 100) * (Percent / 100);
      var total_service_charge_rounded = (Math.ceil(total_service_charge / 10) * 10) * stairs_count * 100;
      
      var quantity = parseInt(total_service_charge_rounded / service_product.price);
      if (service_charge_item.length) {
        var updates = {};
        updates[service_charge_item[0].id] = quantity;
        updateCart(updates).then(refreshCartTotals);
      }
      else {
        addItemToCart({
          variant_id: service_product.variants[0].id,
          quantity: quantity
        }).then(refreshCartTotals);
      }
    });    
  }
  
  $(document).ready(function() {
    $(document).on('change', '#stairs', function(e) {
      var $stairs = $('#stairs');
      var stairs_checked = $stairs.prop('checked');
      $stairs.prop('disabled', true);
      
      $('.stairs-service-count')[stairs_checked ? 'removeClass' : 'addClass']('hide');
    });
    
    $(document).on('change', '#stairs-count', function(e) {
      //console.log(e);
      var stairs_count = parseInt($(e.currentTarget).val());
      addServiceCharge(stairs_count);
    });
    
    getCart().then(function(cart) {
      var stairs_count = parseInt(cart.attributes['Stairs count']);
      var service_charge_added = stairs_count > 0;
      
      if (service_charge_added) {
        $('#stairs').prop('checked', true).trigger('change');
        $('#stairs-count').val(stairs_count);
      }
    });
    
    $(document).on('cart-updated', function(e) {
      //console.log(e);
      var stairs_count = parseInt($('#stairs-count').val());
      if (stairs_count) {
        addServiceCharge(stairs_count);
      }
    });
    
    refreshCartTotals();

    // Delivery or Pickup selection
    $(document).on('click', '.checkoutMethod', function(e) {
      //console.log(e);
      var isPickup = $('.checkoutMethodContainer').hasClass('pickup');
      $('.cart-service-charge').toggleClass('hide', isPickup);
    });  
    
    function removeStairsProduct() {
      $('a[href="/products/service-charge"]').closest('.grid__item').remove();
    }
    
    onElementLoad('.boost-pfs-filter-products', function() {
      observeMutations('.boost-pfs-filter-products', function(m) {
        console.log(m);
        ProductList.prototype.afterRender = function() {
          setTimeout(removeStairsProduct, 1000);
          setTimeout(removeStairsProduct, 2000);
          setTimeout(removeStairsProduct, 3000);
        }
      });      
    });    
  });
})(jQuery);